export class Banque{
	libelle: string;
  domiciliationBancaire: string;
  titulaire: string;
  codeBic: string;
  codeIban: string;
  id: string;
}